<template>
    <div class="form-row">
        <div class="col">
            <div class="form-group">
                <v-layout-select ref="fieldFilter" label="Field Name" :options="fields" :model.sync="model.field" name="field"></v-layout-select>
            </div>
        </div>
        <div class="col">
            <div class="form-group" v-if="type=='text'||type=='string' || type == 'json_text'">
                <v-layout-text label="Field Value" :model.sync="model.value"></v-layout-text>
            </div>
            <div class="form-group" v-if="type=='integer'">
                <v-layout-number :label="startLabel" :model.sync="model.start" min="0" allow_empty="true"></v-layout-number>
                <v-layout-number :label="endLabel" :model.sync="model.end" min="0" allow_empty="true"></v-layout-number>
            </div>
            <div class="form-group" v-if="type==='decimal' || type === 'float'">
                <v-layout-number :label="startLabel" :model.sync="model.start" min="0" step="0.01" :allow_empty="true"></v-layout-number>
                <v-layout-number :label="endLabel" :model.sync="model.end" min="0" step="0.01" :allow_empty="true"></v-layout-number>
            </div>
            <div class="form-group" v-if="type=='boolean'">
                <v-layout-select ref="fieldBoolean" label="Field Value" :options="confirm" :model.sync="boolVal"></v-layout-select>
            </div>
            <div class="form-group" v-if="type=='number_type'">
                <v-layout-select label="Field Value" :options="numberTypes" :model.sync="model.value"></v-layout-select>
            </div>
            <div class="form-group" v-if="type=='confirm_unavailable'">
                <v-layout-select label="Field Value" :options="confirm_unavailable" :model.sync="model.value"></v-layout-select>
            </div>
            <div class="form-group" v-if="type=='date'||type=='datetime'">
                <v-layout-datepicker ref="fieldStart" :label="startLabel" :model.sync="model.start"></v-layout-datepicker>
                <v-layout-datepicker ref="fieldEnd" :label="endLabel" :model.sync="model.end"></v-layout-datepicker>
            </div>
        </div>
        <div class="col">
            <div class="form-group mb-3">
                <button type="button" class="btn btn-secondary" @click="remove_where($event, index)">
                    <i class="fas fa-minus"></i>
                </button>
                <button type="button" class="btn btn-secondary" @click="add_where($event, index)">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["model", "index", "fields", "remove_where", "add_where"],
        data: function(){
            return {
                compares: [
                    {id: "LIKE", text: "LIKE"},
                    {id: "=", text: "="},
                    {id: "!=", text: "!="},
                    {id: "<=", text: "<="},
                    {id: ">=", text: ">="}
                ],
                confirm: window.app_options.confirm,
                confirm_unavailable: window.app_options.confirm_unavailable,
                numberTypes: window.app_options.budget_markup_types,
            }
        },
        computed:{
            startLabel() {
                return this.model.end ? "Start Between" : "Start Between / Date Greater Than";
            },
            endLabel() {
                return this.model.start ? "Start End" : "Start End / Date Lesser Than";
            },
            boolVal: {
                get() {
                    return this.model.value || "0";
                },
                set(val) {
                    this.model.value = val;
                },
            },
            type(){
                let field = this.fields[this.model.field];
                if(typeof field == 'undefined') return "";
                else return field.type;
            },
            options(){

            }
        },
        watch: {
            model(value) {
                const select = this.$refs.fieldFilter.$el.querySelector('select');
                // Double trigger to change select2 value
                $(select).val(value.field).trigger('change');
                $(select).val(value.field).trigger('change');

                setTimeout(() => {
                    const start = this.$refs.fieldStart ? this.$refs.fieldStart.$el.querySelector('input') : null;
                    const end = this.$refs.fieldEnd ? this.$refs.fieldEnd.$el.querySelector('input') : null;
                    const booleanVal = this.$refs.fieldBoolean ? this.$refs.fieldBoolean.$el.querySelector('select') : null;

                    if (start) {
                        $(start).datepicker().value(value.start);
                    }
                    if (end) {
                        $(end).datepicker().value(value.end);
                    }
                    if (booleanVal) {
                        $(booleanVal).val(value.value || "0").trigger('change');
                        $(booleanVal).val(value.value || "0").trigger('change');
                    }
                }, 100);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reports/filter.vue